import script from "./MainView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainView.vue?vue&type=script&setup=true&lang=ts"

import "./MainView.vue?vue&type=style&index=0&id=25193a54&lang=css"

const __exports__ = script;

export default __exports__